import React from "react";
import { DashboardModule } from "./DashboardModule";

export const DashboardGrid = ({ modules, onItemClick, selectedModule }) => {
  return (
    <div className="grid grid-cols-3 gap-4">
      {modules.map((module, index) => (
        <DashboardModule
          key={index}
          imgRef={module.imgRef}
          title={module.title}
          onClick={() => onItemClick(module.title)}
          isSelected={selectedModule === module.title}
        />
      ))}
    </div>
  );
};
